import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "@/lib/site";

export const EditorialMarquee = () => (
  <div className="relative border-y border-white/10 bg-trx-black py-7 overflow-hidden" data-testid="editorial-marquee">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {MARQUEE_ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="mx-14 font-display text-sm md:text-base font-medium uppercase tracking-[0.4em] text-zinc-500">
            {item}
          </span>
          <span className="h-1.5 w-1.5 rotate-45 bg-trx-blue/70" />
        </span>
      ))}
    </Marquee>
  </div>
);
